import { initSwiperSlider, destroySwiperSlider, debounce } from '@theme/utilities';
import { EffectFade, Navigation } from '@theme/swiper-modules';

class ExpertSlider extends HTMLElement {
  connectedCallback() {
    this._onResize = debounce(() => this._positionNav(), 150);
    window.addEventListener('resize', this._onResize);

    this._swiper = initSwiperSlider(this, {
      containerSelector: '.expert-slider__swiper',
      prevSelector: '.expert-slider__prev',
      nextSelector: '.expert-slider__next',
      swiperOptions: {
        modules: [EffectFade, Navigation],
        effect: "fade",
        fadeEffect: { crossFade: true },
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 500,
        on: {
          init: (swiper) => {
            this._updateCounter(swiper);
            this._positionNav();
          },
          slideChange: (swiper) => this._updateCounter(swiper),
        },
      },
    });
  }

  disconnectedCallback() {
    this._onResize?.cancel();
    window.removeEventListener('resize', this._onResize);
    destroySwiperSlider(this, {
      containerSelector: '.expert-slider__swiper',
    });
  }

  _positionNav() {
    const firstSlide = this.querySelector('.swiper-slide');
    const imageCol = firstSlide && firstSlide.querySelector('.shrink-0');
    if (!imageCol) return;

    const { width } = imageCol.getBoundingClientRect();
    const gap = parseInt(getComputedStyle(imageCol.parentElement || firstSlide).gap) || 0;
    this.style.setProperty('--expert-nav-left', `${width + gap}px`);
  }

  /** @param {import('swiper').default} swiper */
  _updateCounter(swiper) {
    const counter = this.querySelector('.expert-slider__counter');
    if (counter) {
      counter.textContent = `${swiper.realIndex + 1}/${swiper.slides.length}`;
    }
  }
}

if (!customElements.get('expert-slider')) {
  customElements.define('expert-slider', ExpertSlider);
}
